import { useState } from "react";

import type { AgeRange } from "@/core/types";
import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { isAuthorized } from "@/utils/authToken";
import { provider_case_manager, provider_peer } from "@/config/roles";

import { AcceptedAgeRangeModal } from "./AcceptedAgeRangeModal";
import { AgeRangeDisplay } from "./AgeRangeDisplay";

type AcceptedAgeRangeProps = {
  acceptedAgeRanges: AgeRange[];
  className?: string;
  noBoxShadow?: boolean;
  setAcceptedAgeRanges: (ranges: AgeRange[]) => void;
};

export function AcceptedAgeRange({
  acceptedAgeRanges,
  setAcceptedAgeRanges,
}: AcceptedAgeRangeProps) {
  const [isAcceptedAgeRangeModalOpen, setIsAcceptedAgeRangeModalOpen] = useState(false);

  const canEdit = !isAuthorized(provider_case_manager) && !isAuthorized(provider_peer);

  return (
    <>
      <AcceptedAgeRangeModal
        acceptedAgeRanges={acceptedAgeRanges}
        isOpen={isAcceptedAgeRangeModalOpen}
        onOpenChange={setIsAcceptedAgeRangeModalOpen}
        setAcceptedAgeRanges={setAcceptedAgeRanges}
      />

      <DashboardCard2
        Actions={
          <Button2
            isDisabled={!canEdit}
            onPress={() => setIsAcceptedAgeRangeModalOpen(true)}
            size="sm"
            variant="link"
            {...getAutomationDataAttr("AcceptedAgeRangeEditButton")}
          >
            Edit
          </Button2>
        }
        className="tw:col-span-2"
        title="Accepted Age Range"
      >
        <div className="tw:flex tw:flex-wrap tw:gap-4" data-public>
          {acceptedAgeRanges.map((acceptedAgeRange, index) => (
            <AgeRangeDisplay key={index} max={acceptedAgeRange.max} min={acceptedAgeRange.min} />
          ))}
        </div>
      </DashboardCard2>
    </>
  );
}
